import { ReactNode } from "react";

export function Grid({
  propertyTree,
  form,
}: {
  propertyTree: ReactNode;
  form: ReactNode;
}) {
  return (
    <div className="grid xl:grid-cols-[300px_1fr] gap-5">
      <div className="relative">
        <div className="xl:absolute xl:top-0 xl:left-0 xl:h-full xl:w-full xl:overflow-auto">
          {propertyTree}
        </div>
      </div>
      <div>{form}</div>
    </div>
  );
}
